import { useMediaQuery } from '@chakra-ui/react';
import React from 'react';
import { theme } from '../../../assets/style/theme';
import { SectionStyle } from './style';

type Props = {
  children: React.ReactNode;
  background?: string;
  bgPath?: string;
  pt?: number;
  pb?: number;
  pl?: number;
  pr?: number;
  visible?: boolean;
  display?: 'block' | 'flex' | 'grid' | 'inline-block' | 'inline-flex' | 'inline-grid' | 'none';
};

function Section({ children, background, bgPath, pt, pb, pl, pr, visible, display }: Props) {

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const ptValue = pt ? pt : isMobile ? 30 : 130;
  const pbValue = pb ? pb : isMobile ? 30 : 130;
  const plValue = pl ? pl : isMobile ? 30 : 0.1;
  const prValue = pr ? pr : isMobile ? 30 : 0.1;

  return (
    <SectionStyle background={background} paddingTop={ptValue} paddingBottom={pbValue} paddingLeft={plValue} paddingRight={prValue} bgPath={bgPath} visible={visible} display={display} >
    <div className="section-inner">
      {children}
    </div>
    </SectionStyle>
  );
}

Section.defaultProps = {
  visible: true,
};

export default Section;
